import { useMutation } from '@apollo/client/react';
import { Navigate, useLocation, useNavigate } from 'react-router';
import { toast } from 'sonner';
import { Fragment } from 'react';

import { AppRequestAcceptDocument } from 'src/graphql/actions/appRequests/appRequestAccept.mutation';
import { useCreateOwnApp, type IOwnApplicationForm } from 'src/containers/Application/model';
import { OwnApplicationForm } from 'src/containers/Application/ui';
import { getApiError, ClientError } from 'src/utils/errors';
import { refetchAppProtections } from 'src/containers/Applications/Protections/api';
import { refetchAppRequests } from 'src/containers/VendorRequests/api';

import { FulfillingRequestBanner } from './FulfillingRequestBanner';

export const CreateFromRequestContainer = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { appRequestId = '', vendorName = '' } = state ?? {};

  const createOwnApp = useCreateOwnApp();
  const [acceptRequest] = useMutation(AppRequestAcceptDocument);

  if (!appRequestId || !vendorName) return <Navigate to="/applications/new" replace />;

  const handleSubmit = async (data: IOwnApplicationForm) => {
    try {
      const appId = await createOwnApp(data);

      const { data: accepted } = await acceptRequest({ variables: { appId, appRequestId } });
      if (!accepted?.appRequestAccept?.success) throw new ClientError(accepted?.appRequestAccept?.errors?.[0]);

      refetchAppRequests();
      refetchAppProtections();
      toast.success(`${vendorName} added as a beneficiary`);
      navigate(`/applications/${appId}`);
    } catch (error) {
      getApiError(error, toast.error);
    }
  };

  const handleCancel = () => navigate(-1);

  return (
    <Fragment>
      <FulfillingRequestBanner vendorName={vendorName} />
      <OwnApplicationForm onSubmit={handleSubmit} onCancel={handleCancel} />
    </Fragment>
  );
};
